/**
 * Why a client's conversation could not be opened, in the words the surface says it in. The
 * trainer's own client profile („TY") is refused by the backend (400 `conversation_with_self`), so
 * it is said as such — and never asked at all where the session already knows the profile. Pure.
 */

export type OpenFailure = 'self' | 'other';

export const CONVERSATION_WITH_SELF = 'conversation_with_self';

/** The trainer's own profile: answered before any request. */
export function isOwnProfile(customerId: number, selfCustomerId: number | null): boolean {
  return selfCustomerId !== null && customerId === selfCustomerId;
}

/** A refusal read off the Problem Details `code`, as a plain string — older backends send none. */
export function openFailureOf(code: string | undefined): OpenFailure {
  return code === CONVERSATION_WITH_SELF ? 'self' : 'other';
}

export function openFailureKey(failure: OpenFailure): string {
  return failure === 'self' ? 'web:chat.compose.self' : 'chat.compose.openFailed';
}
